import { Box, styled, styledComponent, Typography } from '@hermes/web-components'

export const TabsRoot = styled('div')`
  display: flex;
`

export const SearchResultsModalRoot = styled('div')`
  background-color: white;
  display: block;
  filter: drop-shadow(0px 3px 4px rgba(2, 3, 3, 0.03)) drop-shadow(0px 3px 3px rgba(2, 3, 3, 0.02))
    drop-shadow(0px 1px 8px rgba(2, 3, 3, 0.04));
  font-family: Poppins;
  left: 0;
  position: absolute;
  top: calc(100% + 10px);
  width: 100%;
  @media (max-width: 760px) {
    filter: none;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 60px 20px 0 20px;
    box-sizing: border-box;
    overflow-y: auto;
    z-index: 999;
  }
`

export const SearchResultsMobileTitle = {
  fontSize: '16.88px',
  fontWeight: 400,
  marginBottom: '16px',
  lineHeight: '25px',
  color: '#313743'
}

export const HideMobile = styled('div')`
  @media (max-width: 760px) {
    display: none;
  }
`

export const HideDesktop = styled('div')`
  @media (min-width: 760px) {
    display: none;
  }
`

export const RootContainer = styled('div')`
  box-sizing: border-box;
  margin-bottom: 8px;
  margin-top: 8px;
  max-height: 361px;
  overflow-y: auto;
  width: 100%;

  @media (max-width: 760px) {
    max-height: initial;
    overflow-y: hidden;
  }
`

export const ItemRootContainer = styledComponent(Box)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1.5, 2),
  display: 'flex',
  alignItems: 'center',
  minHeight: 47,
  '&:hover': {
    cursor: 'pointer',
    userSelect: 'none',
    backgroundColor: '#f5f5f5'
  }
}))

export const ItemLogo = styled('img')`
  border-radius: 50%;
  height: 48px;
  margin-right: 16px;
  width: 48px;
`
export const ItemTitleContainer = styled('div')`
  display: flex;
  flex-direction: column;
`

export const ItemSubTitle = styledComponent(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.disabled
}))

export const ItemTitle = styledComponent(Typography, {
  shouldForwardProp: (prop: string) => !['specialistOrPractice'].includes(prop)
})<{ specialistOrPractice?: boolean }>(({ theme, specialistOrPractice }) => ({
  ...theme.typography.body2,
  '& .text-highlight': {
    color: theme.palette.primary.main,
    fontWeight: 600
  },
  color: specialistOrPractice ? theme.palette.primary.main : theme.palette.text.primary,
  fontWeight: specialistOrPractice ? 600 : 400
}))
